import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">En kretena jaketo…</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        En kretena jaketo, iam infana palt’ <br/>
        Kun la kapo, plena je bizara rimita frazar’, <br/>
        En Odessa mi estis feliĉa sen fin’, sen kompar’, <br/>
        Sen ĉeval’, sen regno kaj brido por halt’.
      </p>

      <p class="poem-block mb-3">
        En Odessa mi estis – lokusto sur stepa flor’. <br/>
        – Nek ĵuroj, nek larmoj, nek sal’ por kunviva daŭr’. <br/>
        Vi forflugu, revenu – solviĝos ajna dolor’ <br/>
        Pro meliloto polva, lazur’ kaj mituloj ĉe lignofajr’.
      </p>

      <p class="poem-block mb-3">
        Miaj stratoj estas frotitaj de mia paŝ’, <br/>
        La ŝtuparoj platiĝis pro l’ kur’, forlekitaj eĉ ĝis glaci’, <br/>
        Miaj rokoj brilas per dorsoj el mara verdaĵ’, <br/>
        Kaj foreksplodita de l’ Placo Templa la Templ’ de mi.
      </p>

      <p class="poem-block mb-3">
        Sed kiam mi laciĝos, sed resurektos la Templ’, <br/>
        Mi prenos bileton reen, al hejma sin’. <br/>
        Al stratetoj, al varma vespero, memor’ kaj hel’, <br/>
        Kaj kandon vendos al mi mia ciganin’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Abrupte ŝanĝiĝis vento…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Abrupte ŝanĝiĝis vento. <br/>
        La nova deziras venkon. <br/>
        Sieĝas nin la ĉielo, <br/>
        Konkeras suburbojn vent’. <br/>
        Ekhenis ĉevaloj tondre <br/>
        Post muro dikega norda, <br/>
        Sed rompis l’ atak’ unua <br/>
        Remparojn de l’ orient’.
      </p>

      <p class="poem-block mb-3">
        Kaj tuj en la breĉo fuma <br/>
        Pereis ruinaj turoj, <br/>
        Falegis preĝej’ gardanta <br/>
        Kun krucoj kaj ikonar’. <br/>
        La urbo batalis arde, <br/>
        Ĝi estis terura kaj bela, <br/>
        Dum muĝe dronigis ĉielo <br/>
        Restaĵojn de l’ lasta rempar’.
      </p>

      <p class="poem-block mb-3">
        Sed poste, kiam la akvoj <br/>
        Kaj muroj desupre nin premis – <br/>
        Neniu celebris venkon <br/>
        Ilian kun glora kant’. <br/>
        Kaj ili de tiam strebas <br/>
        Imiti iun per modlo; <br/>
        Sed nur detalojn sensencajn <br/>
        Skizigas senpova man’…
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Ĉio, kion mi petis…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ĉio, kion mi petis, <br/>
        Estos por mi, ja estos <br/>
        (Dio mia, ho dankon!): <br/>
        Kaj malproksima vojo, <br/>
        Kaj novaj homoj.
      </p>

      <p class="poem-block mb-3">
        Estos por mi, ja estos <br/>
        Kanto senhejma <br/>
        Kaj memoro fiera. <br/>
        Estos ĉielo <br/>
        Kun la honoro <br/>
        Kaj la mantelo <br/>
        Sub piedoj miaj.
      </p>

      <p class="poem-block mb-3">
        Estos ja –. <br/>
        – Ho, kiam? – <br/>
        Fabelo feliĉa <br/>
        En ment’ kaj absinto. <br/>
        Robo, masko punta <br/>
        Kaj la danco bunta.
      </p>

      <p class="poem-block mb-3">
        Kaj neniu diros: <br/>
        Sufiĉe vi jam vivis!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">La ondo</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Li foriris al mi, forlasinte vin – <br/>
        Ĉu mi kulpas pri io ajn? <br/>
        Tiel gvidis lin spitema destin’. <br/>
        Li iĝis nun mia gajn’.
      </p>

      <p class="poem-block mb-3">
        Do ne staru vi apud mara rand’, <br/>
        Ne atendu ĉe Blanka Rok’! <br/>
        Mi forviŝos la spuron el sabla strand’ <br/>
        En eterna kaj gaja mok’.
      </p>

      <p class="poem-block mb-3">
        Ĉar la vojo mia laŭ strikta ord’ <br/>
        Indikita estas en mar’; <br/>
        Mi venados plu al vilaĝa bord’, <br/>
        Kiel faris mi dum miljar’.
      </p>

      <p class="poem-block mb-3">
        Kaj la saman ordon obeas lun’ <br/>
        Kaj fiŝoj, kaj vir’ el vilaĝ’… <br/>
        Li venadis al maro en vintr’ kaj aŭtun’, <br/>
        Konstante, kun la kuraĝ’.
      </p>

      <p class="poem-block mb-3">
        Li foriris al mi, forlasinte vin, <br/>
        Ja vi scias, memstaras li. <br/>
        Kaj pro sia neŝancelebla obstin’ <br/>
        Min preferis al via lit’.
      </p>

      <p class="poem-block mb-3">
        Mia lito el mara silka herbar’, <br/>
        Mi pretigis ĝin kun zorgem’… <br/>
        Li foriris de vi al la fora mar’, <br/>
        Sed min li elektis mem!
      </p>

      <p class="poem-block mb-3">
        Lian pipon forĵetos mi al la ĝet’, <br/>
        Mi sukcenon donos al vi, <br/>
        Sed lin ne forlasos el silka ret’ – <br/>
        Li restos ĉiam kun mi!
      </p>

      <p class="poem-block mb-3">
        Vi ne ĝisatendos lin, sed, en spit’, <br/>
        Vi venados al Blanka Rok’, <br/>
        Ĝis la grizaj haroj, la lasta spir’ <br/>
        Lin atendos en sama lok’.
      </p>

      <p class="poem-block mb-3">
        Vi ja estas obstina en sama grad’ <br/>
        Kaj iam, al fora mar’ <br/>
        Vi postsekvos lin laŭ la sama pad’ <br/>
        Inter balanciĝanta ondar’.
      </p>

      <p class="poem-block mb-3">
        Via gent’ obstina al mara senlim’ <br/>
        Daŭrigos la vojon ĝis rand’… <br/>
        Kaj iu trovos la pipon de li <br/>
        Sur la sabla-sukcena strand’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Antaŭnokte…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Antaŭnokte <br/>
        Herbon pinĉas ĉevaloj sur kamp’ de l’ morgaŭa batalo. <br/>
        Militestroj <br/>
        Per cirkeloj mezuras  kampojn eventualajn. <br/>
        Kaj verŝiĝis <br/>
        Sur la voj’ formika ankoraŭ nek plumbo, nek sango. <br/>
        Nur matene – <br/>
        Ektondros, kaj levos vizieron l’ rajdanto kun palaj vangoj.
      </p>

      <p class="poem-block mb-3">
        Antaŭnokte <br/>
        Veteranoj dividas sperton kun junularo. <br/>
        Oficiroj <br/>
        Skribas hejmen, kaj jen eksonis gitaro. <br/>
        Silentiĝas <br/>
        Por nokt’ la herboj mielodoraj sur kamp’ despera. <br/>
        Sed matene – <br/>
        Ektondros, kaj jam de mortintoj estos leteroj.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Ho, nur ne pensi pri la voj’ libera…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ho, nur ne pensi pri la voj’ libera, <br/>
        Por iri, paŝi larĝe, sen konvoj’! <br/>
        Min gardu, mia intelekt’ severa, <br/>
        Ne lasu min senbrida en mezvoj’! <br/>
        Ankoraŭ longe spitu ni obstine <br/>
        Al nokt’ prizona, plena je sufok’, <br/>
        Al sonĝ’ karcera, preskaŭ halucina, <br/>
        Ekzekutista sadismema mok’, <br/>
        Perfid’ de l’ laciĝintaj, la veneno <br/>
        De l’ kis’ ilia… Iru kontraŭ flu’ <br/>
        En morn’ nebula, ĝis la vivmarĝeno, <br/>
        Sen rajto diri: «Mi ne povas plu…». <br/>
        Ne cedu al perfida emocio, <br/>
        Rezistu  al kapitulac-inklin’! <br/>
        En temp’ tenebra gardu min, racio! <br/>
        Min gardu – tiam mi konservos vin.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Nu, ne tiel timige…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Nu, ne tiel timige, sed ia deprim’ kaj torp’, <br/>
        Kaj domaĝe, ke eble jam pasis ebleco naski, <br/>
        Ĉar febliĝas la brakoj, la kor’ minacas fiaski. <br/>
        Mi min tenas, sed damne! - perfidas min mia korp’. <br/>
        Verki librojn por infanar’ mi povintus, mi ŝatis ĉevalojn, <br/>
        Ŝatis sidi sur vert’ de la roko mia en mar’. <br/>
        Kaj scipovis pritaksi antaŭ naĝad’ miajn fortojn realajn, <br/>
        Sed tamen alnaĝi iel, kiam la pritakson difektis erar’. <br/>
        Mi ankoraŭ flugis en sonĝ’, kaj en sang’ leviĝis defio <br/>
        Pro la pens’, ke baldaŭ alvenos por mi la  vic’. <br/>
        Sed jam estis dirite: «Ja se ne vi, do kiu?», <br/>
        Jam delonge dirite, por mi ne eblis evit’. <br/>
        Ĉar hontinda estas ĉe tabl’ diskuto senfara, <br/>
        Ĉar pereas ĉiam plej bonaj de l’ homa uni’. <br/>
        Preĝu vi, Patro Aleks, pro la navigantoj en maro, <br/>
        Kaj ankaŭ pro l’ ter’, forlasita por ĉiam de ni.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Oni tempon konservis…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Oni tempon konservis en form’ de  likvaĵo dilua. <br/>
        Kaj la nokton densegan almiksis al tiu buljon’. <br/>
        La dudeka tenebras. Kaj foras la dudek unua, <br/>
        Forviŝonta la nomojn de l’ muro de nia prizon’. <br/>
        Ni ĝin ŝarĝis per voĉoj de la pereintaj amikoj, <br/>
        Nomoj de nenaskitaj infanoj por nova la mur’. <br/>
        Ni ĝin tiel atendis, kun tia zorgemo ekipis, <br/>
        Sed ne rajtas ni remi nek flosi al fora futur’. <br/>
        Tamen ni, protektante per kruda bastmato la grenon, <br/>
        Ĝin sukcesas ankoraŭ kribradi kun la inĝeni’, <br/>
        Estu vundoj sur polmoj, sed  dentojn de l’ drako forpreni <br/>
        El la semoj, kreskontaj abunde en tempoj post ni.
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Irina Ratuŝinskaja'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;